
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.086.531h1.937c.615 1.35 1.253 3.48 1.914 6.39 1.183-1.64 1.774-3.093 1.774-4.359 0-.614-.094-1.158-.281-1.632V.53h1.523c.057.35.086.698.086 1.047 0 .922-.213 1.841-.64 2.758-.428.911-1.209 2.156-2.344 3.734h-1.04c-.5-1.906-.95-3.442-1.35-4.61-.397-1.17-.696-1.871-.9-2.1C.563 1.13.336.991.086.944V.531z","fill":"currentColor"}})])
          )
        }
      }
    